export default __webpack_public_path__ + "static/6-todo-output-b815803a31138386da97f1e9875326b7.png";